// client/src/hooks/useMatriculasCurso.js
// Espelha mobile/src/hooks/useMatriculasCurso.ts — mesmos endpoints
// (/matriculas-curso), só sem os tipos TS.
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import useAlert from './useAlert';

const KEY = 'matriculasCurso';

export const useMatriculasCurso = (params = {}) =>
    useQuery({
        queryKey: [KEY, params],
        queryFn: () => api.get('/matriculas-curso', { params }).then(r => r.data.data || []),
        enabled: !!(params.cliente || params.curso),
        staleTime: 30 * 1000,
    });

export const useMutateMatriculasCurso = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    const invalidate = () => queryClient.invalidateQueries({ queryKey: [KEY] });
    const getErrorMessage = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

    const concluirMatricula = useMutation({
        mutationFn: (id) => api.patch(`/matriculas-curso/${id}/concluir`),
        onSuccess: () => {
            invalidate();
            setAlert('Matrícula concluída! Certificado liberado.', 'success');
        },
        onError: (err) => setAlert(getErrorMessage(err, 'Erro ao concluir matrícula.'), 'danger'),
    });

    const cancelarMatricula = useMutation({
        mutationFn: (id) => api.patch(`/matriculas-curso/${id}/cancelar`),
        onSuccess: () => {
            invalidate();
            setAlert('Matrícula cancelada.', 'success');
        },
        onError: (err) => setAlert(getErrorMessage(err, 'Erro ao cancelar matrícula.'), 'danger'),
    });

    return { concluirMatricula, cancelarMatricula, isPending: concluirMatricula.isPending || cancelarMatricula.isPending };
};

export default useMatriculasCurso;
